import fetch from "../auth/FetchInterceptor";
const StoryService = {
  fetchFilter: function (page: number, limit = 12) {
    return fetch({
      url: `/story/list?page=${page}&limit=${limit}`,
      method: "get",
      headers: {
        "public-request": "true",
      },
    });
  },
  update: function (data: any, id: string) {
    return fetch({
      url: `/story/update/${id}`,
      method: "put",
      data: data,
      headers: {
        "public-request": "true",
      },
    });
  },
  getOne: function (data: string) {
    return fetch({
      url: `/story-getone/${data}`,
      method: "get",
      headers: {
        "public-request": "true",
      },
    });
  },

  addThumbnail: function (data: any) {
    return fetch({
      url: `/stroy-thumbnail/add`,
      method: "post",
      data: data,
      headers: {
        "public-request": "true",
        "content-type": "multipart/form-data",
      },
    });
  },
  create: function (data?: any) {
    return fetch({
      url: `/story/create`,
      method: "post",
      data: data,
      headers: {
        "public-request": "true",
      },
    });
  },

  delete: function (data: string) {
    return fetch({
      url: `/story/delete/${data}`,
      method: "delete",
      headers: {
        "public-request": "true",
      },
    });
  },
};

export default StoryService;
